import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { PATHS } from "../../routes/paths";

interface BlockedUserProps {
  show?: boolean;
  handleClose?: () => void;
}

const BlockedUser = ({ show = true, handleClose }: BlockedUserProps) => {
  const navigate = useNavigate();
  const onClose = handleClose ?? (() => navigate(PATHS.LOGIN));
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="text-center p-4">
        <h3 className="text-custom-blue fw-bold">Usuário Bloqueado</h3>
        <p className="text-muted">Entre em contato com o ds@fiemg.com.br</p>
      </Modal.Body>
    </Modal>
  );
};

export default BlockedUser;
